/** returns Agencies List
@return { Array }
*/
export const getAgenciesList = state => state.agenciesList

/** returns Agencies Provinces List
@return { Array }
*/
export const getAgenciesProvincesList = state => state.agenciesProvincesList
